var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79688 3.43687C1.79688 2.97562 2.17094 2.60156 2.63219 2.60156H15.3644C15.8256 2.60156 16.1997 2.97562 16.1997 3.43687C16.1997 3.65906 16.1125 3.87 15.955 4.0275L11.2469 8.73V14.3662C11.2469 14.8275 10.8728 15.2016 10.4116 15.2016C10.1894 15.2016 9.97844 15.1144 9.82094 14.9569L6.94375 12.0797C6.81719 11.9531 6.74688 11.7816 6.74688 11.6016V8.73L2.04156 4.02469C1.88406 3.87 1.79688 3.65625 1.79688 3.43687ZM3.87531 3.95156L7.9 7.97344C8.02656 8.1 8.09688 8.27156 8.09688 8.45156V11.3231L9.89688 13.1231V8.45156C9.89688 8.27156 9.96719 8.1 10.0938 7.97344L14.1156 3.95156H3.87531Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fd2a7f9f687f13a2c452e83b4acec5ae.svg";
export { ForwardRef as ReactComponent };